var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244.596,
    height: 344.384,
    viewBox: "0 0 244.596 344.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M220.67,45.62c-30.153.39-55.878,9.76-74.942,33.812a69.7,69.7,0,0,0-10.054,18.417c-3.649,9.608-1.378,13.96,8.315,16.868a139.854,139.854,0,0,0,21.81,4.571c17.98,2.366,33.841,8.315,44.845,23.786,2.148,3.012,5.046,5.483,7.479,8.306C229.688,164.8,244.485,168.1,261.277,165.3c15.452-2.566,30.79-16.013,35.6-30.106a18.329,18.329,0,0,0,1.292-2.813c7.46-21.059-3.9-42.773-3.9-42.773-1.169-2.129-2.129-4.257-3.412-6.149C274.305,59.019,252.068,45.62,222,45.62h-1.311Z",
    transform: "translate(-134.029 -45.62)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M318.311,134.516c-6.519,6.2-12.316,13.19-18.17,20.052-10.206,11.964-22.437,19.861-38.469,21.743a113.129,113.129,0,0,0-22.247,5.35,7.69,7.69,0,0,0-2.214,1.235c-8.942,5.3-40.93,27.664-18.588,64.887a20.289,20.289,0,0,1,1.558,2.946,14.715,14.715,0,0,0,3.83,4.932,86.828,86.828,0,0,0,12.135,10.159c19.51,12.544,40.122,11.508,61.067,4.219,11.812-4.115,22.133-10.444,30.353-20.365,15.348-15.889,18.75-30.819,18.75-30.819a84.22,84.22,0,0,0,6.719-45.045c-1.559-13.77-5.36-26.97-14.587-37.908-3.83-4.523-6.966-6.823-10.282-6.823-2.946,0-6.025,1.8-9.855,5.445h0Z",
    transform: "translate(-210.845 -129.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M140.188,136.643c-17.22,8.857-26.5,27.93-26.5,27.93-5.322,11.812-8.648,23.435-8.9,35.722-.808,38.25,31.36,79.142,69.886,89.225,0,0,16.146,6.12,28.766.627,7.2-1.3,10.054-3.915,9.085-10.5a151.647,151.647,0,0,0-5.7-23.264c-.067-.2-.152-.4-.228-.589-2.024-7.8-4.039-16.326-5.208-21.363a40.369,40.369,0,0,1-1-11.4c.694-6.747,3.212-13.029,5.578-19.377.836-1.815,1.749-3.649,2.756-5.493,9.247-16.954,3.146-30.419,3.146-30.419-5.835-21.078-21.23-34.667-42.964-37.414a40.3,40.3,0,0,0-5.018-.314c-8.3,0-16.117,2.575-23.71,6.633h0Z",
    transform: "translate(-104.764 -130.01)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mol\\xE9cule_3D",
    "data-name": "mol\\xE9cule 3D",
    transform: "translate(-100.313 -19.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M206.824,256.383c-.067-.2-.152-.4-.228-.589-2.015-7.8-4.039-16.326-5.208-21.363a40.368,40.368,0,0,1-1-11.4c.694-6.747,3.212-13.029,5.578-19.367q1.254-2.723,2.756-5.493c9.247-16.954,3.155-30.419,3.155-30.419-5.835-21.078-21.23-34.667-42.964-37.414-10.187-1.283-19.624,1.454-28.728,6.32-17.22,8.857-26.5,27.93-26.5,27.93-5.312,11.812-8.648,23.435-8.9,35.722-.8,38.25,31.36,79.142,69.886,89.225,0,0,16.146,6.12,28.766.627,7.2-1.3,10.054-3.915,9.085-10.5a151.65,151.65,0,0,0-5.7-23.264",
    transform: "translate(-4.452 -29.329)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M136.185,339.115s2.936-14.663,16.127-13.19,11.727,21.99,10.263,32.254S155.248,369.9,152.312,369.9c-2.566,0-12.991,2.243-16.535-11.926a30.206,30.206,0,0,1-.561-11.119l.969-7.745Z",
    transform: "translate(-5.941 -38.401)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M206.824,256.383c-.067-.2-.152-.4-.228-.589-2.015-7.8-4.039-16.326-5.208-21.363a40.368,40.368,0,0,1-1-11.4c.694-6.747,3.212-13.029,5.578-19.367q1.254-2.723,2.756-5.493c9.247-16.954,3.155-30.419,3.155-30.419-5.835-21.078-21.23-34.667-42.964-37.414-10.187-1.283-19.624,1.454-28.728,6.32-17.22,8.857-26.5,27.93-26.5,27.93-5.312,11.812-8.648,23.435-8.9,35.722-.8,38.25,31.36,79.142,69.886,89.225,0,0,16.146,6.12,28.766.627,7.2-1.3,10.054-3.915,9.085-10.5a151.65,151.65,0,0,0-5.7-23.264",
    transform: "translate(-4.452 -29.329)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M294.262,89.61c-1.169-2.129-2.129-4.257-3.412-6.149-16.8-24.8-39.447-38.231-70.171-37.832-30.163.39-55.878,9.769-74.942,33.812a69.555,69.555,0,0,0-10.054,18.417c-3.649,9.608-1.378,13.97,8.315,16.868a140.078,140.078,0,0,0,21.81,4.571c17.98,2.366,33.841,8.315,44.845,23.786,2.148,3.012,5.046,5.483,7.479,8.306,11.565,13.418,26.362,16.716,43.154,13.922,15.452-2.566,30.79-16.013,35.589-30.106a18.329,18.329,0,0,0,1.292-2.813c7.46-21.059-3.9-42.773-3.9-42.773",
    transform: "translate(-5.463 -25.934)",
    fill: "#23004c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M353.046,173.8c-1.559-13.77-5.36-26.97-14.587-37.9-7.213-8.534-11.983-9.142-20.137-1.387-6.519,6.206-12.316,13.19-18.17,20.052-10.2,11.964-22.427,19.861-38.469,21.743a113.135,113.135,0,0,0-22.247,5.35,7.843,7.843,0,0,0-2.2,1.226c-8.942,5.312-40.93,27.673-18.588,64.9a19.348,19.348,0,0,1,1.549,2.946,14.714,14.714,0,0,0,3.83,4.932,86.824,86.824,0,0,0,12.135,10.159c19.51,12.544,40.122,11.508,61.077,4.219,11.812-4.115,22.133-10.444,30.353-20.375,15.348-15.889,18.75-30.819,18.75-30.819a84.254,84.254,0,0,0,6.719-45.054",
    transform: "translate(-8.766 -29.328)",
    fill: "#715ec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M315.654,358.547c-6.576-21.762-14.188-43.2-21.42-64.764a25.964,25.964,0,0,0-1.673-3.754c-1.616-3.041-3.63-4.058-7.175-2.366a24.9,24.9,0,0,1-9.066,2.129c-14.454.8-28.585-.589-42.013-6.671-7.051-3.193-7.688-2.756-11.024,4.371-3.022,6.481-6.272,12.649-13.513,15.595a151.2,151.2,0,0,1-30.581,2c-.532-.028-1.083-.057-1.682-.095-1.806.257-4.267.38-4.856,1.9-1.711,4.343-3.516,7.678-4.343,11.242-3.1,13.352-6.377,26.7-8.6,40.217a125.324,125.324,0,0,0-1.4,26.343c.589,11.926,6.453,16.944,18.122,15.138a47.164,47.164,0,0,0,18.227-7.3c11.622-7.707,18.759-19.367,24.451-31.835,8-17.533,14.407-35.532,14.274-55.242l1.435-.085c.751,1.977,1.511,3.953,2.252,5.93,4.742,12.677,9.427,25.364,14.226,38.022,6.11,16.127,16.773,28.823,30.676,38.649a66.311,66.311,0,0,0,18.208,9.237c10.663,3.307,18.55-2.5,18.569-13.779.019-8.325-.722-16.992-3.108-24.908",
    transform: "translate(-6.481 -36.116)",
    fill: "#715ec9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(128.566 19.686)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(137.73 48.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M321.477,118.068A21.258,21.258,0,1,1,300.218,96.81a21.258,21.258,0,0,1,21.259,21.258h0",
    transform: "translate(-278.96 -96.81)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20",
    transform: "translate(202.08 99.752)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(107.248 70.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M366.217,224.528a21.258,21.258,0,1,1-21.258-21.258,21.258,21.258,0,0,1,21.258,21.258h0",
    transform: "translate(-323.7 -203.27)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(100.313 100.681)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(8.663 -5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M156.4,145.838a21.258,21.258,0,1,1-21.258-21.258A21.258,21.258,0,0,1,156.4,145.838h0",
    transform: "translate(-113.88 -124.58)",
    fill: "#f36c87"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M233.78,192.275a10.615,10.615,0,1,1-10.615-10.615h0a10.614,10.614,0,0,1,10.615,10.615h0",
    transform: "translate(-9.381 -31.928)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M233.78,192.275a10.615,10.615,0,1,1-10.615-10.615h0a10.614,10.614,0,0,1,10.615,10.615Z",
    transform: "translate(-9.381 -31.928)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M223.81,253.365a10.615,10.615,0,1,1-10.615-10.615h0a10.614,10.614,0,0,1,10.615,10.615",
    transform: "translate(-8.941 -34.703)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M223.81,253.365a10.615,10.615,0,1,1-10.615-10.615h0A10.614,10.614,0,0,1,223.81,253.365Z",
    transform: "translate(-8.941 -34.703)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M210.79,299.535a10.61,10.61,0,1,1-10.615-10.605h0a10.61,10.61,0,0,1,10.605,10.605",
    transform: "translate(-8.367 -36.8)",
    fill: "#f36c87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M210.79,299.535a10.61,10.61,0,1,1-10.615-10.605h0a10.61,10.61,0,0,1,10.605,10.605Z",
    transform: "translate(-8.367 -36.8)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitial);
export default __webpack_public_path__ + "static/media/initial.962f413b5c4966d4e868aebf29dd7de4.svg";
export { ForwardRef as ReactComponent };